import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import LoadingSpinner from '../components/LoadingSpinner';
import { useAdminAuth } from '../contexts/AdminAuthContext';

export default function AuthCallbackPage(): React.JSX.Element {
  const { completeLogin, error } = useAdminAuth();
  const navigate = useNavigate();

  useEffect(() => {
    let cancelled = false;

    void (async () => {
      try {
        const returnTo = await completeLogin();
        if (!cancelled) {
          navigate(returnTo, { replace: true });
        }
      } catch {
        // Error state is already captured in context.
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [completeLogin, navigate]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-950 px-6 text-white">
      <div className="w-full max-w-md rounded-3xl border border-white/10 bg-slate-900/80 p-8 text-center shadow-[0_30px_80px_-40px_rgba(15,23,42,0.85)] backdrop-blur">
        <div className="flex justify-center">
          <LoadingSpinner size="lg" />
        </div>
        <h1 className="mt-6 text-2xl font-semibold">Completing sign-in</h1>
        <p className="mt-3 text-sm leading-6 text-slate-300">
          Exchanging the authorization code with rule42-auth and establishing your billing session.
        </p>
        {error && (
          <div className="mt-6 rounded-2xl border border-red-500/30 bg-red-500/10 p-3 text-sm text-red-200">
            {error}
          </div>
        )}
      </div>
    </div>
  );
}